import { UiDomUtils } from '@dreamcommerce/utilities';
import { MenuKeyboardNavigation } from '@frontstoreRwd/modules/rwd_menu/menu_navigation/menu_keyboard_navigation';
import Features from '@core/tools/features';

;(function (undefined) {
	Shop.RwdMenu.include({
        options: {
            buttonSelector: '.small-menu .fa.fa-align-justify',
            iconDown: 'fa afa-chevron-down',
            iconUp: 'fa afa-chevron-up',
            menuBarSelector: 'nav.innermenu'
        },

        objects: {
            categories: null,
            menu: null
        },

        events: {
            create: null,
            toggle: null
        },

        initialize: function(options) {
            this.constructor.setOptions(options);
            var shopClass = this.parent;

            this.events.create = (function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                if((shopClass.rwd.small || shopClass.rwd.mid) && !this.objects.categories) {
                    this.createMenu(shopClass);
                    $(this.options.buttonSelector).off('click', this.events.create);
                }
            }.bind(this));

            $(this.options.buttonSelector).on('click', this.events.create);

            if (Features.isEnabled('menu_navigation_rwd')) {
                const $button = document.querySelector(this.options.buttonSelector);

                if ($button) {
                    $button.id = 'rwd-menu-button';
                    $button.setAttribute('aria-controls', 'rwd-menu');
                    $button.setAttribute('aria-owns', 'rwd-menu');
                    $button.setAttribute('aria-expanded', 'false');
                    $button.setAttribute('role', 'button');
                }

                const $menuBar = document.querySelector(this.options.menuBarSelector);

                if (!$menuBar) return;

                const menuKeyboardNavigation = new MenuKeyboardNavigation($menuBar);

                document.addEventListener('mousedown', (ev) => {
                    const $target = ev.target;

                    const { $topLevelItemsWithSubmenu, hideMenu } = menuKeyboardNavigation.navigationUtils;

                    $topLevelItemsWithSubmenu.forEach(($menuItem) => {
                        if (!$menuItem.contains($target)) hideMenu($menuItem);
                    });
                });
            }
        },

        createMenu: function (shopClass) {
            var that = this;

            if (shopClass.rwd.small || shopClass.rwd.mid) {
                $.ajax({
                    url: shopClass.url('console/tree/gettree/client/1'),
                    method: 'get'
                }).error(function () {

                }).success(function (categories, state, xhrObject) {
                    if (state === 'success') {
                        that.objects.categories = categories;
                        that.buildMainCategory();
                    }
                });
            }
        },

        buildNode: function (tree, submenu) {
            var that;
            var category;
            var index;
            var li;
            var a;

            that = this;
            for (category in tree) {
                if (Object.prototype.hasOwnProperty.call(tree, category)) {
                    li = $('<li />', {
                        'class': tree[category].children.length > 0 ? 'has-children ' + this.options.iconDown : '',
                        'data-category-id': tree[category].id,
                        click: function(e) {
                            if($(this).hasClass('has-children')) {
                                e.stopPropagation();

                                if ($(this).hasClass('active')) {
                                    $(this).removeClass('active').removeClass(that.options.iconUp).addClass(that.options.iconDown).children('ul').hide();
                                } else {
                                    index = $(this).index();
                                    that.buildSubCategory($(this), tree[index].children);
                                    $(this).removeClass(that.options.iconDown).addClass(that.options.iconUp + ' active');
                                    $(this).children('ul').show();
                                }
                            }
                        }
                    }).appendTo(submenu);

                    a = $('<a />', {
                        'text': tree[category].name,
                        'href': tree[category].url,
                        click: function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            $(this).next().hide();
                            window.location.href = $(this).attr('href');
                        }
                    }).appendTo(li);
                }
            }
        },

        buildMainCategory: function() {
            if(!this.objects.menu) {
                var that = this,
                    additionalLinks = $('.menu-list a'),
                    tree = this.objects.categories.tree,
                    menu = this.objects.menu = $('<ul />', {
                        'id': 'rwd-menu',
                        'class': 'small active',
                        'aria-modal': 'true',
                        'aria-labelledby': 'rwd-menu-button',
                        'role': 'menu'
                    }).appendTo($('.menu.row nav'));

                this.buildNode(tree, menu);

                if (additionalLinks.length > 0) {
                    this.buildAdditionalLinks(menu, additionalLinks);
                }

                this.events.toggle = (function (ev) {
                    ev.preventDefault();
                    ev.stopPropagation();

                    const $menu = this.objects.menu.toggleClass('active none small');
                    const $button = document.querySelector(this.options.buttonSelector);

                    if (Features.isEnabled('menu_navigation_rwd')) {
                        if ($menu.hasClass('none')) {
                            if (!$button) return;

                            $button.setAttribute('aria-expanded', 'false');
                            $button.focus();
                        }
                        else {
                            $button && $button.setAttribute('aria-expanded', 'true');
                            UiDomUtils.getFocusableElement(this.objects.menu[0])?.focus();
                        }
                    }
                }.bind(this));

                $(this.options.buttonSelector).on('click', this.events.toggle);

                if (Features.isEnabled('menu_navigation_rwd')) {
                    $(this.objects.menu).on('keydown', (ev) => {
                        if (ev.key === 'Escape') this.events.toggle(ev);

                        if (ev.key === 'Tab') {
                            this.handleFocusTrap(ev);
                        }
                    });

                    UiDomUtils.getFocusableElement(this.objects.menu[0])?.focus();
                    $(this.options.buttonSelector).attr('aria-expanded', 'true');
                }
            }
        },

        handleFocusTrap(ev) {
            const $target = ev.target;
            const $menu = this.objects.menu[0];

            if (!$target || !$menu) return;

            const $firstMenuLink = UiDomUtils.getFocusableElement($menu);
            const $lastMenuLink = UiDomUtils.getLastFocusableElement($menu);

            if ($firstMenuLink && ev.target === $firstMenuLink && ev.shiftKey) {
                ev.preventDefault();
                UiDomUtils.getLastFocusableElement($menu)?.focus();
                return;
            }

            if ($lastMenuLink && ev.target === $lastMenuLink && !ev.shiftKey) {
                ev.preventDefault();
                UiDomUtils.getFocusableElement($menu)?.focus();
            }
        },

        buildSubCategory: function(li, tree) {
            var submenuId = parseInt(li.attr('data-category-id'), 10);

            if(tree.length > 0 && !this.objects.menu[submenuId]) {
                var that = this;
                var submenu = this.objects.menu[submenuId] = $('<ul />').appendTo(li);
        
                this.buildNode(tree, submenu);
            }       
        },

        buildAdditionalLinks: function (menu, additionalLinks) {
            additionalLinks.each(function (index) {
                var li;
                var $el;

                $el = $(this);
                
                if ($el.attr('href') !== '/' && $el.parents('li').attr('id') === undefined && index) {
                    li = $('<li />').appendTo(menu)
                    $('<a />', {
                        'text': $el.text(),
                        'href': $el.attr('href')
                    }).appendTo(li);
                }
            });
        }
    });
})();